import types from './types';

const INITIAL_STATE = {
    isChecking: false,
    isFetching: false,
    isSaving: false,

  result: [],
};

const authSurveyReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.CHECK_SURVEY_REQUEST:
        return {
            ...state,
            result: [],
            isChecking: true,
        };

    case types.CHECK_SURVEY_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isChecking: false,
        };

    case types.CHECK_SURVEY_FAILURE:
        return {
            ...state,
            result: [],
            isChecking: false,
        };

    case types.GET_SURVEY_QUESTIONS_REQUEST:
        return {
            ...state,
            result: [],
            isFetching: true,
        };

    case types.GET_SURVEY_QUESTIONS_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isFetching: false,
        };

    case types.GET_SURVEY_QUESTIONS_FAILURE:
        return {
            ...state,
            result: [],
            isFetching: false,
        };

    case types.SAVE_SURVEY_REQUEST:
        return {
            ...state,
            result: [],
            isSaving: true,
        };

    case types.SAVE_SURVEY_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isSaving: false,
        };

    case types.SAVE_SURVEY_FAILURE:
        return {
            ...state,
            result: [],
            isSaving: false,
        };

    default:
      return state;
  }
};

export default authSurveyReducer;
